import AdminAffectationsMenuItem from '@/components/header/user/AdminAffectationsMenuItem';
import AffectationsMenuItem from '@/components/header/user/AffectationsMenuItem';
import IngestionsMenuItem from '@/components/header/user/IngestionsMenuItem';
import SusMenuItem from '@/components/header/user/SusMenuItem';
import ThesaurusMenuItem from '@/components/header/user/ThesaurusMenuItem';
import UserHelpMenuItem from '@/components/header/user/UserHelpMenuItem';
import UserProfilMenuItem from '@/components/header/user/UserProfilMenuItem';
import { baseApi } from '@/features/api/baseApi';
import { logoutDirectusSession } from '@/features/api/directus';
import { useOidc } from '@/shared/auth/oidc';
import { useIsAdmin } from '@/shared/auth/useDirectusUser';
import { useUserEtablissements } from '@/shared/auth/useUserEtablissements';
import { getUserDisplayName } from '@/shared/utils/oidc.utils';
import { Avatar, Box, Group, Menu, Text, Tooltip, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconCrown, IconLogout, IconUserCode } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import cx from 'clsx';
import { useState } from 'react';
import { useMatch } from 'react-router-dom';
import classes from '../Header.module.css';

const UserMenu = () => {
  const { t } = useTranslate();
  const oidc = useOidc();
  const isAdmin = useIsAdmin();
  const { finess } = useUserEtablissements();
  const hasEtablissement = finess.length > 0;
  const isOnboardingPage = useMatch('/onboarding');

  const userDisplayName = oidc.isUserLoggedIn ? getUserDisplayName(oidc.decodedIdToken) : '';

  const [userMenuOpened, setUserMenuOpened] = useState(false);

  const handleLogout = async () => {
    if (!oidc.isUserLoggedIn) return;

    await logoutDirectusSession();
    baseApi.util.resetApiState();
    oidc.logout({
      redirectTo: 'home',
    });
  };

  return (
    <Menu
      position="bottom-end"
      transitionProps={{ transition: 'pop-top-right' }}
      onClose={() => setUserMenuOpened(false)}
      onOpen={() => setUserMenuOpened(true)}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton className={cx(classes.user, { [classes.userActive]: userMenuOpened })}>
          <Group gap={7} wrap="nowrap">
            {isAdmin ? (
              <Tooltip label={t('auth.role.admin')} withArrow>
                <Avatar radius="xl" aria-label={t('auth.role.admin')}>
                  <IconCrown />
                </Avatar>
              </Tooltip>
            ) : (
              <Tooltip label={t('auth.role.user')} withArrow>
                <Avatar radius="xl" aria-label={t('auth.role.user')} />
              </Tooltip>
            )}
            <Text fw={500} size="sm" lh={1} visibleFrom="xs">
              {userDisplayName}
            </Text>
            <IconChevronDown stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {!isOnboardingPage && (
          <>
            <AffectationsMenuItem />
            {isAdmin && <AdminAffectationsMenuItem />}
            {(isAdmin || hasEtablissement) && <IngestionsMenuItem />}
            {(isAdmin || hasEtablissement) && <SusMenuItem />}
            {(isAdmin || hasEtablissement) && <ThesaurusMenuItem />}
            <UserProfilMenuItem />
            <Box hiddenFrom="sm">
              <UserHelpMenuItem />
            </Box>
            <Menu.Divider />
            <Menu.Item leftSection={<IconUserCode stroke={1.5} />} disabled>
              {t('auth.impersonation')}
            </Menu.Item>
          </>
        )}
        <Menu.Item leftSection={<IconLogout stroke={1.5} />} onClick={handleLogout}>
          {t('auth.logout')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default UserMenu;
